export default __webpack_public_path__ + "static/SR France - Métaux lourds - Note d'information-4e4f2730725da151cc13d3bc99e827dd.pdf";